'use client';

import { preload } from 'react-dom';
import { HERO_BACKGROUND_SRC } from '@/lib/hero-preload';

/**
 * HeroBackground Component
 *
 * Shared parallax backdrop for hero sections (catalog + static pages).
 *
 * Этот SVG — LCP-элемент на всех страницах с hero. Основной сигнал приоритета
 * даёт заголовок `Link` из `proxy.ts` (приходит до первого байта HTML);
 * preload ниже — страховка на случай маршрута, не покрытого списком в
 * `lib/hero-preload.ts`. Дубля запроса не будет: браузер дедуплицирует
 * предзагрузки по URL.
 *
 * ref прокидывается наружу — вызывающий компонент двигает подложку при скролле.
 */

interface HeroBackgroundProps {
  ref?: React.Ref<HTMLDivElement>;
}

export function HeroBackground({ ref }: HeroBackgroundProps) {
  preload(HERO_BACKGROUND_SRC, { as: 'image', fetchPriority: 'high' });

  return (
    <div
      ref={ref}
      className="absolute inset-0 will-change-transform"
      style={{ top: '-15%', bottom: '-15%' }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={HERO_BACKGROUND_SRC}
        alt=""
        className="h-full w-full object-cover"
        loading="eager"
        // Совпадает с fetchpriority в preload — иначе Chrome может не сматчить
        // предзагрузку с реальным запросом и сходить в сеть дважды.
        fetchPriority="high"
        decoding="async"
      />
    </div>
  );
}
